import { render } from "./App.vue?vue&type=template&id=b02d8f9c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b02d8f9c&lang=css"
script.render = render

export default script